import { createFileRoute } from '@tanstack/react-router'

import { CommTemplatesProductPage } from '#/modules/intake/comm-templates-product-page'

export const Route = createFileRoute('/_shell/comm-templates')({
  component: CommTemplatesProductPage,
})
